class DeleteCandidateDocumentController {
    /*@ngInject*/
    constructor($rootScope, MESSAGECONSTANTS, documentService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.documentService = documentService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    $onInit() {
        this.savingFlag = false;
        this.deleteLatestVersion = true;
    }
    delete() {
        this.savingFlag = true;
        this.deleteDocumentPayload.keepLastVersion = this.deleteLatestVersion;
        this.documentService.deleteCandidateDocument(this.deleteDocumentPayload, () => {
            this.savingFlag = false;
            if (this.saveCallback) {
                this.saveCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
        });
    }
    cancel() {
        if (this.cancelCallback) {
            this.cancelCallback();
        }
    }
}
DeleteCandidateDocumentController.$inject = ['$rootScope', 'MESSAGECONSTANTS', 'documentService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './delete-candidate-document.html';
import * as TEMPLATE from 'raw-loader!./delete-candidate-document.html';
export const DeleteCandidateDocumentComponent = {
    selector: 'deleteCandidateDocument',
    component: {
        bindings: {
            document: '<',
            deleteDocumentPayload: '<',
            saveCallback: '&',
            cancelCallback: '&'
        },
        controller: DeleteCandidateDocumentController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateprofile/candidateProfile/candidateDocuments/deleteCandidateDocument/delete-candidate-document.html'
    }
};
//# sourceMappingURL=delete-candidate-document.component.js.map